import { QuickActionType, QuickActionConfig } from '../types';

export const QUICK_ACTION_CONFIGS: Record<QuickActionType, QuickActionConfig> = {
  agenda: {
    type: 'agenda',
    icon: '📅',
    label: 'Agenda',
    enabled: true,
  },
  inbox: {
    type: 'inbox',
    icon: '📬',
    label: 'Inbox',
    enabled: true,
  },
  newsfeed: {
    type: 'newsfeed',
    icon: '📰',
    label: 'NewsFeed',
    enabled: true,
  },
  profile: {
    type: 'profile',
    icon: '👤',
    label: 'Profiel',
    enabled: true,
  },
};

export const DEFAULT_QUICK_ACTION: QuickActionType = 'agenda';

export function getQuickActionConfig(type: QuickActionType): QuickActionConfig {
  return QUICK_ACTION_CONFIGS[type] || QUICK_ACTION_CONFIGS[DEFAULT_QUICK_ACTION];
}

export function getAllQuickActions(): QuickActionConfig[] {
  return Object.values(QUICK_ACTION_CONFIGS).filter(config => config.enabled);
}

























